import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueSweetAlert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask'

import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VueTheMask);
Vue.use(VueSweetAlert2);

require('./components/');
import './assets/scripts/formatter'
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
